import api from 'src/shared/api/axios';
import type { Risk, RiskStatus, RAG } from '../types/risk.type';

// ✅ Task 패턴처럼 Input/Patch 타입 정의
export type CreateRiskInput = {
    title: string;
    category?: string | null;
    description?: string | null;

    wbsNodeId?: string | null;
    milestoneId?: string | null;

    probability?: number | null;
    impact?: number | null;
    score?: number | null;
    rag?: RAG | null;

    dueDate?: string | null;
    mitigationPlan?: string | null;
    contingencyPlan?: string | null;
    weeklyNote?: string | null;
    nextReviewAt?: string | null;

    status?: RiskStatus;
    closedNote?: string | null;

    ownerUserId?: string | null; // null이면 서버 default(createdBy)
};

export type UpdateRiskPatch = Partial<CreateRiskInput>;

export async function apiListRisks(
    projectId: string,
    params?: { includeClosed?: boolean; category?: string },
): Promise<Risk[]> {
    const { data } = await api.get(`/projects/${projectId}/risks`, { params });
    return data.data ?? data;
}

export async function apiCreateRisk(projectId: string, input: CreateRiskInput): Promise<Risk> {
    const { data } = await api.post(`/projects/${projectId}/risks`, input);
    return data.data ?? data;
}

export async function apiUpdateRisk(projectId: string, riskId: string, patch: UpdateRiskPatch): Promise<Risk> {
    const { data } = await api.patch(`/projects/${projectId}/risks/${riskId}`, patch);
    return data.data ?? data;
}

export async function apiDeleteRisk(projectId: string, riskId: string): Promise<boolean> {
    const { data } = await api.delete(`/projects/${projectId}/risks/${riskId}`);
    const v = data.data ?? data;
    return v === true;
}

export async function apiGetRiskCategories(projectId: string): Promise<string[]> {
    const { data } = await api.get(`/projects/${projectId}/risks/categories`);
    return data.data ?? data ?? [];
}
